
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import FormBase from '@/components/helper/form-base.vue';
    import ModalView from '@/components/helper/modal-view.vue';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import quiz from '@/store/entities/cems/quiz';

    @Component({
        components: { FormBase, ModalView },
        watch: {
            value: function (val) {
                let obj = (this as any);
                obj.modalShow = val;
                if (val) {
                    obj.quiz = Util.extend(true, {}, this.$store.state.quiz.editModel);
                    obj.initForm();
                }
            },
            modalShow: function (val) {
                if (!val) {
                    this.$emit('input', false);
                } else {
                    (this as any).initForm();
                }
            }
        }
    })

    export default class quizForm extends ListBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        quiz: quiz = new quiz();
        modalShow: boolean = false;
        selectedItem: any = null;
        modalSetting: any = {
            entity: "quiz",
            titleFull: 'Encuesta de Satisfacci&oacute;n del Cliente',
            width: "1000px",
            showForm: false,
            persistent: false,
            showFootActions: false,
            disabledSave: true
        };
        
        get dealer() {
            return this.$store.state.app.dealer;
        }

        getInitials(string) {
            return Util.getInitials(string);
        }

        initForm() {

            if (this.quiz.id > 0) {
            } else {
                this.quiz.dealer_id = this.dealer;
            }
        }

        async save() {
            if ((this.$refs.entityForm1 as any).validate()) {
                
            }
        }

        cancel() {
            this.$emit('input', false);
        }

        async mounted() {
        }

        async created() {
        }
    }
